var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('text',{attrs:{"x":"2","y":"18","font-size":"24px","stroke":"0x000000"}},[_vm._v("↣")])])
}
var staticRenderFns = []

export { render, staticRenderFns }